<template>
    <v-card>
        <v-toolbar flat color="purple" dark>
            <v-toolbar-title>{{ trans('document-checklist.edit-title') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-if="!disabled" v-model="templateDialogOpen" persistent scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn color="white" outlined small rounded v-on="on"><v-icon left>menu_open</v-icon>
                        {{ trans('document-checklist.templates-btn') }}</v-btn>
                </template>
                <DocumentChecklistTemplateEditor v-model="data" @close="templateDialogOpen = false" @load="loadTemplate" />
            </v-dialog>
        </v-toolbar>
        <v-card-text v-if="error">
            <error-badge v-model="error" />
        </v-card-text>
        <v-card-text class="pa-0">
            <v-form v-model="validForm" ref="form">
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>{{ trans('document-checklist.fields.done') }}</th>
                                <th>{{ trans('document-checklist.fields.title') }}</th>
                                <th>{{ trans('document-checklist.fields.description') }}</th>
                                <th>{{ trans('document-checklist.fields.category') }}</th>
                                <th>{{ trans('document-checklist.fields.is_private') }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in data" :class="item.done ? 'green lighten-5' : ''">
                                <td>
                                    <v-icon v-if="item.done" color="success" dense>task_alt</v-icon>
                                    <v-icon v-else color="grey" dense>radio_button_unchecked</v-icon>
                                </td>
                                <td>
                                    <v-text-field dense v-model="item.title"
                                        :label="trans('document-checklist.fields.title')" :rules="rules.title" />
                                </td>
                                <td>
                                    <v-text-field dense v-model="item.description"
                                        :label="trans('document-checklist.fields.description')"
                                        v-bind="{ loading: isLoading, disabled }" />
                                </td>
                                <td>
                                    <v-combobox small-chips dense :items="categories" v-model="item.category"
                                        :label="trans('document-checklist.fields.category')"
                                        v-bind="{ loading: isLoading, disabled }" />
                                </td>
                                <td>
                                    <v-switch v-model="item.is_private" dense
                                        :label="trans('document-checklist.fields.is_private')"
                                        v-bind="{ loading: isLoading, disabled }" />
                                </td>
                                <td>
                                    <v-btn v-if="!disabled" icon color="error" @click="removeRow(item)"
                                        v-bind="{ loading: isLoading, disabled }"><v-icon>delete</v-icon></v-btn>

                                    <v-btn v-if="!disabled && item.done" icon color="purple"
                                        @click="removeUploadedFile(item)"
                                        v-bind="{ loading: isLoading, disabled }"><v-icon>link_off</v-icon></v-btn>
                                </td>

                            </tr>
                        </tbody>
                        <tfoot v-if="!disabled">
                            <tr>
                                <td colspan="6" class="text-center pa-2">
                                    <v-btn color="success" small outlined v-bind="{ loading: isLoading, disabled }"
                                        @click="addRow"><v-icon left>add</v-icon>
                                        {{ trans('document-checklist.add-row') }}</v-btn>
                                </td>
                            </tr>
                        </tfoot>
                    </template>
                </v-simple-table>
            </v-form>
        </v-card-text>
        <v-divider class="my-2"></v-divider>
        <v-card-actions>
            <v-btn @click="cancel" v-if="hasBeenModified" v-bind="{ loading: isLoading, disabled }" outlined
                color="error"><v-icon left>close</v-icon>{{
                    trans('common.cancel')
                }}</v-btn>
            <v-btn v-else @click="cancel" v-bind="{ loading: isLoading, disabled }" outlined color="grey"><v-icon
                    left>close</v-icon>{{
                        trans('common.close')
                    }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="save" v-if="!disabled" v-bind="{ loading: isLoading, disabled }" color="primary"><v-icon
                    left>save</v-icon>{{
                        trans('common.save') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { Vuelidator, Rule } from '../../Vuelidator/index';
import DocumentChecklistTemplateEditor from './DocumentChecklistEditor/DocumentChecklistTemplateEditor.vue';

export default {
    props: {
        projectId: { type: Number, required: true, },
        value: { type: Array, required: true, },
        disabled: { type: Boolean, default: false, },
        loading: { type: Boolean, default: false, },
    },
    data() {
        //deep clone
        let data = JSON.parse(JSON.stringify(this.value));

        let vuelidator = new Vuelidator({
            title: [Rule.string(), Rule.required()],
        })

        let rules = vuelidator.getRules();

        return {
            data,

            rules,
            validForm: false,
            templateDialogOpen: false,

            hasBeenModified: false,

            processing: false,
            error: null,
        }
    },
    computed: {
        categories() {
            let uniqueMap = {};
            for (let e of this.data) {
                uniqueMap[e.category] = e.category;
            }
            ///list unique categories
            return Object.values(uniqueMap);
        },
        isLoading() {
            return this.loading || this.processing;
        },
    },
    methods: {
        cancel() {
            if (!this.hasBeenModified || confirm('Chiudendo  la pagina perderai tutte le modifiche,confermi?')) {
                this.$emit('close');
            }
        },
        async save() {
            this.$refs.form.validate();
            if (!this.validForm) {
                return;//validation error
            }

            this.processing = true;
            this.error = null;

            try {
                const r = await axios.patch(`/projects/${this.projectId}/document-list`, { document_lists: this.data });
                console.warn('SUBMIT', r.data);
                if (r.data.response !== 'ok') {
                    throw r;
                }
                this.$emit('submitted', r.data.data);
                this.hasBeenModified = false;

            } catch (e) {
                this.error = e;
            } finally {
                this.processing = false;
            }


            //this.$emit('close');
        },
        addRow() {
            this.data.push({
                done: false,
                title: '',
                description: '',
                category: '',
            });
        },
        removeRow(item) {
            if (confirm(trans('common.confirm-delete'))) {
                if (item.done && confirm('È presente un file caricato per questo documento, confermare cancellazione?')) {
                    this.data.splice(this.data.indexOf(item), 1);
                }
            }
        },
        async removeUploadedFile(item) {
            if (confirm(trans('Confermi di voler eliminare il file caricato?'))) {

                this.processing = true;
                this.error = null;
                try {
                    const r = await axios.delete(`/projects/${this.projectId}/document-list/${item.id}`);
                    if (r?.data?.response === 'ok') {
                        item.done = false;
                        item.url = null;
                        item.user = null;
                        item.uploaded_at = null;

                        let original = this.value.find(e => e.id == item.id)
                        if (original) {
                            original.done = false;
                            original.url = null;
                            original.user = null;
                            original.uploaded_at = null;
                        }

                    } else {
                        throw new Error(r?.data?.response);
                    }
                } catch (e) {
                    this.error = e;
                } finally {
                    this.processing = false;
                }
            }
        },
        loadTemplate(data) {
            this.data = data;
            this.templateDialogOpen = false;
        },
    },
    watch: {
        data: {
            deep: true,
            handler() {
                this.hasBeenModified = true;
            }
        }
    },
    components: {
        DocumentChecklistTemplateEditor,
    },
}
</script>